import { db } from './db';
import type { StageEffect } from '../types/stage';

/**
 * What a spoken or typed request actually does to the house. One implementation for every
 * surface, so "doe het licht uit" means the same on the wall, the desk and the phone.
 */
export function applyStageEffect(effect?: StageEffect) {
  if (!effect) return;
  if (effect.type === 'light') db.setLight(effect.room, effect.value);
  if (effect.type === 'target') db.setTarget(effect.room, effect.value);
  if (effect.type === 'coffee') {
    db.setDevice('koffie', 'aan');
    db.log({ agent: 'huis', summary: 'Koffiezetapparaat aan', level: 'zelf', where: 'lokaal', outcome: 'uitgevoerd', traceId: 'koffie' });
  }
  if (effect.type === 'refuse') {
    db.log({ agent: 'huis', summary: `Verzoek geweigerd: ${effect.subject}`, level: 'nooit', where: 'lokaal', outcome: 'geweigerd', traceId: `weigering-${effect.subject}` });
  }
}
